var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('Menu',{staticClass:"pc",attrs:{"MenuData":_vm.MenuData}}),_c('SideMenu',{staticClass:"phone",attrs:{"MenuData":_vm.MenuData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }